<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:body>
            <div class="table-responsive">
              <b-table-simple class="text-center">
                <b-thead>
                  <b-tr v-if="planType">
                    <th></th>
                    <th v-bind:class="{
                      'text-danger': planType.type === 'STANDARD',
                    }">
                      Éstandar
                    </th>
                    <th v-bind:class="{
                      'text-danger': planType.type === 'PREMIUM',
                    }">
                      Premium
                    </th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(item, index) in rows" :key="index">
                    <th scope="row">{{ item.name }}</th>
                    <td>
                      <template v-if="item.button">
                        <h2>
                          {{ item.starter }}
                          <small>{{ item.starter_per }}</small>
                        </h2>
                        <b-button v-if="planType.type === 'FREE'" variant="primary  mt-3"
                          @click="changeStandardPlanType">Cambiar
                        </b-button>
                      </template>
                      <i v-if="item.starter && !item.button" class="ri-check-line ri-2x text-success" />
                      {{ item.priceStandard }}
                    </td>
                    <td>
                      <template v-if="item.button">
                        <h2>
                          {{ item.business }}
                          <small>{{ item.business_per }}</small>
                        </h2>
                        <b-button v-if="planType.type !== 'PREMIUM'" variant="primary  mt-3"
                          @click="changePremiumPlanType">Cambiar
                        </b-button>
                      </template>
                      <i v-if="item.business && !item.button" class="ri-check-line ri-2x text-success" />
                      {{ item.pricePremium }}
                    </td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import organizationService from "../../services/organization";

export default {
  name: "PreferencesAccountPricing",
  mounted() {
    xray.index();
    this.getPlanTypes();
  },
  props: {
    planType: undefined,
  },
  methods: {
    async changePremiumPlanType() {
      let self = this;

      let planType = self.planTypes.find((option) => option.type === "PREMIUM");

      this.$awn.asyncBlock(
        organizationService.activePlanTypePremium(
          localStorage.getItem("organizationId"),
          planType.id
        ),
        (response) => {
          if (response) {
            self.getPlanTypes();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.activePlanTypePremium",
            module: "component-organization-preferencesAccountPricing",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId"),
              planType: planType.id
            }),
          });
        },
        " "
      );
    },
    async getPlanTypes() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findAllPlanTypeById(
          localStorage.getItem("organizationId")
        ),
        (response) => {
          if (response) {
            self.planTypes = response.data;
            self.generateHeaderColumns();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findAllPlanTypeById",
            module: "component-organization-preferencesAccountPricing",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId"),
            }),
          });
        },
        " "
      );
    },
    async generateHeaderColumns() {
      let headerColumn = [
        {
          key: "name",
          label: "",
        },
      ];
      this.planTypes.forEach((element) => {
        let row = {
          key: element.id,
          label: element.name,
        };

        headerColumn.push(row);
      });

      this.headerColumn = headerColumn;

      this.generateData();
    },
    generateData() {
      const data = new Map();
      data.set("monthlyRateMinutesMonoconferenceProfessional", {
        name: "Número de minutos de monoconferencia incluidos al mes",
        free: false,
        starter: false,
        business: false,
        adhoc: false,
      });
      data.set("monthlyRateMinutesMulticonferenceProfessional", {
        name: "Número de minutos de multiconferencia incluidos al mes",
        free: false,
        starter: false,
        business: false,
        adhoc: false,
      });

      data.set("priceCallPhone", {
        name: "Precio recordatorio teléfono",
        free: false,
        starter: false,
        business: false,
        adhoc: false,
      });
      data.set("priceMessageSms", {
        name: "Precio recordatorio SMS",
        free: false,
        starter: false,
        business: false,
        adhoc: false,
      });
      data.set("priceMessageWhatapp", {
        name: "Precio recordatorio WhatsApp",
        free: false,
        starter: false,
        business: false,
        adhoc: false,
      });
      data.set("priceMinuteMonoconference", {
        name: "Precio minuto videoconferencia",
        free: false,
        starter: false,
        business: false,
        adhoc: false,
      });
      data.set("priceMinuteMulticonference", {
        name: "Precio minuto multiconferencia",
        free: false,
        starter: false,
        business: false,
        adhoc: false,
      });
      data.set("priceMinuteRecording", {
        name: "Precio minuto grabación",
        free: false,
        starter: false,
        business: false,
        adhoc: false,
      });
      data.set("buttons", {
        name: "",
        button: true,
        free: "",
        free_per: "Gratuito",
        starter: "30€",
        starter_per: "/mes",
        business: "50€",
        business_per: "/mes",
        adhoc: "",
        adhoc_per: "A medida",
      });
      let keys = Array.from(data.values());

      this.planTypes.forEach((element) => {
        if (element.type === "FREE" && this.planType.type === "FREE") {
          if (element.monthlyRateMinutesMonoconferenceProfessional !== -1) {
            data.get("monthlyRateMinutesMonoconferenceProfessional").priceFree =
              element.monthlyRateMinutesMonoconferenceProfessional + " minutos";
          }

          if (element.monthlyRateMinutesMulticonferenceProfessional !== -1) {
            data.get(
              "monthlyRateMinutesMulticonferenceProfessional"
            ).priceFree =
              element.monthlyRateMinutesMulticonferenceProfessional +
              " minutos";
          }

          if (element.priceCallPhone !== -1) {
            data.get("priceCallPhone").priceFree =
              element.priceCallPhone + " €";
          }
          if (element.priceMessageSms !== -1) {
            data.get("priceMessageSms").priceFree =
              element.priceMessageSms + " €";
          }
          if (element.priceMessageWhatapp !== -1) {
            data.get("priceMessageWhatapp").priceFree =
              element.priceMessageWhatapp + " €";
          }
          if (element.priceMinuteMonoconference !== -1) {
            data.get("priceMinuteMonoconference").priceFree =
              element.priceMinuteMonoconference + " €";
          }
          if (element.priceMinuteMulticonference !== -1) {
            data.get("priceMinuteMulticonference").priceFree =
              element.priceMinuteMulticonference + " €";
          }
          if (element.priceMinuteRecording !== -1) {
            data.get("priceMinuteRecording").priceFree =
              element.priceMinuteRecording + " €";
          }
        }
        if (
          element.type === "STANDARD" &&
          (this.planType.type === "FREE" || this.planType.type === "STANDARD")
        ) {
          if (element.monthlyRateMinutesMonoconferenceProfessional !== -1) {
            data.get(
              "monthlyRateMinutesMonoconferenceProfessional"
            ).priceStandard =
              element.monthlyRateMinutesMonoconferenceProfessional + " minutos";
          }
          if (element.monthlyRateMinutesMulticonferenceProfessional !== -1) {
            data.get(
              "monthlyRateMinutesMulticonferenceProfessional"
            ).priceStandard =
              element.monthlyRateMinutesMulticonferenceProfessional +
              " minutos";
          }
          if (element.priceCallPhone !== -1) {
            data.get("priceCallPhone").priceStandard =
              element.priceCallPhone + " €";
          }
          if (element.priceMessageSms !== -1) {
            data.get("priceMessageSms").priceStandard =
              element.priceMessageSms + " €";
          }
          if (element.priceMessageWhatapp !== -1) {
            data.get("priceMessageWhatapp").priceStandard =
              element.priceMessageWhatapp + " €";
          }
          if (element.priceMinuteMonoconference !== -1) {
            data.get("priceMinuteMonoconference").priceStandard =
              element.priceMinuteMonoconference + " €";
          }
          if (element.priceMinuteMulticonference !== -1) {
            data.get("priceMinuteMulticonference").priceStandard =
              element.priceMinuteMulticonference + " €";
          }
          if (element.priceMinuteRecording !== -1) {
            data.get("priceMinuteRecording").priceStandard =
              element.priceMinuteRecording + " €";
          }
        }
        if (
          element.type === "PREMIUM" &&
          (this.planType.type === "FREE" ||
            this.planType.type === "STANDARD" ||
            this.planType.type === "PREMIUM")
        ) {
          if (element.monthlyRateMinutesMonoconferenceProfessional !== -1) {
            data.get(
              "monthlyRateMinutesMonoconferenceProfessional"
            ).pricePremium =
              element.monthlyRateMinutesMonoconferenceProfessional + " minutos";
          }
          if (element.monthlyRateMinutesMulticonferenceProfessional !== -1) {
            data.get(
              "monthlyRateMinutesMulticonferenceProfessional"
            ).pricePremium =
              element.monthlyRateMinutesMulticonferenceProfessional +
              " minutos";
          }
          if (element.priceCallPhone !== -1) {
            data.get("priceCallPhone").pricePremium =
              element.priceCallPhone + " €";
          }
          if (element.priceMessageSms !== -1) {
            data.get("priceMessageSms").pricePremium =
              element.priceMessageSms + " €";
          }
          if (element.priceMessageWhatapp !== -1) {
            data.get("priceMessageWhatapp").pricePremium =
              element.priceMessageWhatapp + " €";
          }
          if (element.priceMinuteMonoconference !== -1) {
            data.get("priceMinuteMonoconference").pricePremium =
              element.priceMinuteMonoconference + " €";
          }
          if (element.priceMinuteMulticonference !== -1) {
            data.get("priceMinuteMulticonference").pricePremium =
              element.priceMinuteMulticonference + " €";
          }
          if (element.priceMinuteRecording !== -1) {
            data.get("priceMinuteRecording").pricePremium =
              element.priceMinuteRecording + " €";
          }
        }
        if (element.type === "ADHOC" && this.planType.type === "PREMIUM") {
          if (element.monthlyRateMinutesMonoconferenceProfessional !== -1) {
            data.get(
              "monthlyRateMinutesMonoconferenceProfessional"
            ).priceAdhoc =
              element.monthlyRateMinutesMonoconferenceProfessional + " minutos";
          }
          if (element.monthlyRateMinutesMulticonferenceProfessional !== -1) {
            data.get(
              "monthlyRateMinutesMulticonferenceProfessional"
            ).priceAdhoc =
              element.monthlyRateMinutesMulticonferenceProfessional + " €";
          }
          if (element.priceCallPhone !== -1) {
            data.get("priceCallPhone").priceAdhoc =
              element.priceCallPhone + " €";
          }
          if (element.priceMessageSms !== -1) {
            data.get("priceMessageSms").priceAdhoc =
              element.priceMessageSms + " €";
          }
          if (element.priceMessageWhatapp !== -1) {
            data.get("priceMessageWhatapp").priceAdhoc =
              element.priceMessageWhatapp + " €";
          }
          if (element.priceMinuteMonoconference !== -1) {
            data.get("priceMinuteMonoconference").priceAdhoc =
              element.priceMinuteMonoconference + " €";
          }
          if (element.priceMinuteMulticonference !== -1) {
            data.get("priceMinuteMulticonference").priceAdhoc =
              element.priceMinuteMulticonference + " €";
          }
          if (element.priceMinuteRecording !== -1) {
            data.get("priceMinuteRecording").priceAdhoc =
              element.priceMinuteRecording + " €";
          }
        }
      });

      this.rows = keys;
    },
  },
  data() {
    return {
      planTypes: [],
      headerColumn: [],
      rows: [],
    };
  },
};
</script>
